module.exports = __webpack_public_path__ + "static/media/RuralSpark.be157c51.png";